/* Cart drawer: the Add buttons of the sticker upsell row (snippets/ast-cart-upsell.liquid) and of the sticker pack
   meter's suggestions (snippets/ast-cart-pack.liquid), and the product page deal card's "Add both" button
   (snippets/ast-buybox.liquid, data-variant-ids), which adds every listed variant and opens the drawer.
   One delegated listener on the document, because the drawer's markup is replaced on every cart change
   (cart-drawer.js renderContents, cart-items.js renderSections) and a listener on the row would go with it.
   The add goes through the theme's cart route with the drawer and cart icon sections asked for in the same
   response, then those sections are rendered the way product-form.js does, so the drawer updates in place:
   the row disappears (the sticker is now in the cart), the line items, shipping line and subtotal update. */
(function () {
  if (window.astCartUpsellBound) return;
  window.astCartUpsellBound = true;

  function cartError(message) {
    var generic = (window.theme && theme.strings && theme.strings.cartError) || 'Something went wrong. Please try again.';
    return /^[0-9]*$/.test(String(message)) ? generic : String(message);
  }

  async function addUpsell(btn) {
    var row = btn.closest('.ast-cart-upsell, .ast-pack, .ast-deal, .ast-shipgap');
    var msg = row ? row.querySelector('.ast-cart-upsell__msg, .ast-pack__msg, .ast-deal__msg, .ast-shipgap__msg') : null;
    var ids = String(btn.dataset.variantIds || btn.dataset.variantId || '').split(',').filter(Boolean);
    var openDrawer = btn.classList.contains('ast-deal__add');
    var drawer = document.getElementById('cart-drawer');
    var label = btn.textContent;
    var routes = (window.theme && theme.routes) || {};
    var addUrl = (routes.cartAdd || '/cart/add') + '.js';
    var sections = ['cart-icon-bubble'];
    var drawerSection = drawer ? drawer.closest('.shopify-section') : null;
    if (drawerSection) sections.push(drawerSection.id.replace('shopify-section-', ''));

    var body = {
      // data-src marks where an add came from (the free-shipping row sends _ast_src: ship-gap; spec S1)
      items: ids.map(function (id) {
        var line = { id: Number(id), quantity: 1 };
        if (btn.dataset.src) line.properties = { _ast_src: btn.dataset.src };
        return line;
      }),
      sections: sections.join(','),
      sections_url: window.location.pathname
    };

    // The words say what is happening (AST, Oct 15 2026): "Adding…" in the button's own colours, never the
    // theme's is-loading look, which made the label transparent
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('data-ast-state', 'adding');
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.textContent = btn.dataset.adding || 'Adding\u2026';
    if (msg) { msg.hidden = true; msg.textContent = ''; }

    try {
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await response.json();
      if (!response.ok) {
        throw new Error(typeof data.description === 'string' ? data.description : (data.message || response.status));
      }

      if (drawer && typeof drawer.renderContents === 'function') {
        try {
          await drawer.renderContents(data, openDrawer);
        } catch (renderError) {
          // The response carried no drawer markup: fetch the drawer again so it shows the real cart
          drawer.refresh(true);
        }
      } else if (document.getElementById('ast-cart-pack-page')) {
        // /cart (no drawer there): reload so the items, the meter and the summary show the new cart
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }
      // A button the re-render didn't replace (the deal card's "Add both" on the product page) says "Added" for
      // 1.2s, then gets its label back
      if (btn.isConnected) {
        btn.removeAttribute('aria-busy');
        btn.setAttribute('data-ast-state', 'added');
        btn.textContent = btn.dataset.added || 'Added';
        setTimeout(function () {
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('data-ast-state');
          btn.style.minWidth = '';
          btn.textContent = label;
        }, 1200);
      }
    } catch (error) {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('data-ast-state');
      btn.style.minWidth = '';
      btn.textContent = label;
      if (msg) {
        msg.textContent = cartError(error.message);
        msg.hidden = false;
      }
      console.log(error); // eslint-disable-line
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('.ast-cart-upsell__btn, .ast-pack__add, .ast-deal__add, .ast-shipgap__btn') : null;
    if (!btn) return;
    evt.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    addUpsell(btn);
  });
})();
